
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submission-login",
      function () {
        return require("private-next-pages/submission-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submission-login"])
      });
    }
  